import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import PlusLogoOutlinedSVG from '../../assets/plusLogo-outlined.svg';

export type LogoLinkProps = {
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
};

export const LogoLink = ({
  width = 80,
  height = 80,
  className,
  onClick,
}: LogoLinkProps) => {
  return (
    <Link
      to={ROUTES.home}
      className={clsx(
        'flex justify-center items-center',
        'hover:cursor-pointer',
        className
      )}
      style={{ width, height }}
      onClick={onClick}
    >
      <img
        src={PlusLogoOutlinedSVG}
        alt="Plus Aprendizagens"
        width={width}
        height={height}
      />
    </Link>
  );
};
